import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  LinearProgress,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  attachUserWithMove,
  getMoveService,
  getUserByPhoneNumber,
  updateMoveService,
} from "../../redux/action/move-service";
import { unwrapResult } from "@reduxjs/toolkit";
import Header from "../header/Header";
import Packing from "../packing/Packing";
import StepProgress from "../stepsProgress/stepsProgress";
const Pricing = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isPackingDropdownOpen, setIsPackingDropdownOpen] = useState(true);
  const [selectedPackingOption, setSelectedPackingOption] = useState("");
  const { canonicalId, carrierCanonicalId, businessName } = useParams();
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const [withPacking, setWithPacking] = useState(false);
  const isStorageOnly = "storage";
  const withoutPackingPrice = 300;
  const withPackingPrice = 800;
  const [totalPriceWithPacking, setTotalPriceWithPacking] = useState(0.0);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const lastStep = 10;
  const phoneNumber = localStorage.getItem("phoneNumber");
  const [userId, setUserId] = useState(null);
  useEffect(() => {
    if (phoneNumber) {
      dispatch<any>(getUserByPhoneNumber(phoneNumber))
        .then(unwrapResult)
        .then((res: any) => {
          setUserId(res.id);
        })
        .catch((error: any) => {
          console.error("Error fetching user by phone number:", error);
          setError("User with this phone number not found.");
        });
    }
  }, []);

  useEffect(() => {
    const updateLastStep = async () => {
      const moveServiceData = {
        canonical_id: canonicalId,
        last_step: lastStep,
      };
      await dispatch<any>(updateMoveService(moveServiceData))
        .then(unwrapResult)
        .then((res: any) => {});
    };

    if (canonicalId) {
      updateLastStep();
    }
  }, [canonicalId, dispatch, lastStep]);
  const handlePackingOptionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "With Packing") {
      setWithPacking(true);
      setSelectedPackingOption(`With Packing`);
    } else if (value === "Without Packing") {
      setWithPacking(false);
      setSelectedPackingOption(`Without Packing`);
    }
  };
  const [targetLongDistanceRates, setTargeLongDistanceRates] = useState<any>(
    []
  );
  const [packingBoxesCount, setPackingBoxesCount] = useState<{
    smallBoxes: number;
    mediumBoxes: number;
    largeBoxes: number;
    dishPacks: number;
    mirrorCartons: number;
    wardrobeBoxes: number;
  }>({
    smallBoxes: 0,
    mediumBoxes: 0,
    largeBoxes: 0,
    dishPacks: 0,
    mirrorCartons: 0,
    wardrobeBoxes: 0,
  });
  const [moveService, setMoveService] = useState<any>(null);
  const getMoveById = () => {
    dispatch<any>(getMoveService(canonicalId || ""))
      .then(unwrapResult)
      .then((res: any) => {
        setSquareFootage(Number(res.pickup_square_footage));
        setMoveService(res);
        if (res.dwelling_type === "apartment" || res.dwelling_type === "home") {
          if (res.distance > 200) {
            setTotalCubicFeet(res.total_cubic_feet);
          }
        } else if (res.dwelling_type === "storage" && res.distance > 200) {
          setTotalCubicFeet(res.storage.storage_cubic_feet);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  const submitLeadToSmartMoving = async () => {
    if (!moveService) return;
    try {
      const providerKey = moveService.carrier?.crm_api_key;
      if (
        providerKey !== null &&
        providerKey !== undefined &&
        providerKey !== ""
      ) {
        if (!providerKey) {
          // setError("No CRM API key found for this carrier");
          return;
        }
        const movingDate = moveService.moving_date
          ? new Date(moveService.moving_date).toISOString().split("T")[0]
          : null;
        const isTestEnvironment =
          process.env.REACT_APP_URL === "http://localhost:3000" ||
          process.env.REACT_APP_URL ===
            "https://staging-booking-tool-react-app-8e4b4d3d9707.herokuapp.com";
        const payload = {
          firstName: isTestEnvironment ? "test" : moveService.user?.firstName,
          lastName: isTestEnvironment ? "test" : moveService.user?.lastName,
          phoneNumber: moveService.phone_number,
          email: isTestEnvironment ? "test@gmail.com" : moveService.user?.email,
          moveDate: movingDate,
          bedrooms: moveService.number_of_bedrooms,
          moveSize:
            parseFloat(moveService.distance || "0") > 200
              ? moveService.total_cubic_feet
                ? `${moveService.total_cubic_feet} cubic feet`
                : null
              : moveService.pickup_square_footage
              ? `${moveService.pickup_square_footage} sqft`
              : null,
          movingItems:
            parseFloat(moveService.distance || "0") > 200
              ? {
                  inventory: moveService.inventory
                    ? {
                        inventoryData: moveService.inventory.inventory
                          ? JSON.parse(moveService.inventory.inventory)
                          : null,
                      }
                    : null,
                }
              : {
                  BulkyItems: moveService.items
                    ? JSON.parse(moveService.items)
                    : null,
                },
          originAddress: moveService.moving_from,
          destinationAddress: moveService.moving_to,
          moveType: moveService.move_type,
          dwellingType: moveService.dwelling_type,
          floorNumber: moveService.floor_number,
          hasElevator: moveService.isElevator ? "Yes" : "No",
          hasStairs: moveService.isStairs ? "Yes" : "No",
          isPackingRequired: moveService.isPackingRequired ? "Yes" : "No",
          isInsurance: moveService.isInsurance ? "Yes" : "No",
          distance: moveService.distance,
          duration: moveService.duration_time,
          notes: `Move Type: ${moveService.move_type}\nDwelling Type: ${
            moveService.dwelling_type
          }\nFloor Number: ${moveService.floor_number}\nElevator: ${
            moveService.isElevator ? "Yes" : "No"
          }`,
        };
        const endpoint = `https://api.smartmoving.com/api/leads/from-provider/v2?providerKey=${providerKey}`;
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          const errorData = await response.json();
          // setError(`SmartMoving API error: ${errorData}`);
        }
        const responseData = await response.json();
        const moveServiceData = {
          canonical_id: canonicalId,
          smartmoving_lead_id: responseData.leadId,
        };
        await dispatch<any>(updateMoveService(moveServiceData))
          .then(unwrapResult)
          .then((res: any) => {});
      }
    } catch (error) {
      console.error("Error submitting lead to SmartMoving:", error);
    }
  };

  const handleContinue = async () => {
    setError(null);
    setIsLoading(true);
    setLoadingMessage("Processing your pricing and packing details...");

    try {
      const moveServiceData = {
        canonical_id: canonicalId,
        price: Math.ceil(totalMovePrice).toString(),
        isPackingRequired: withPacking,
        price_of_items_only: Math.ceil(priceOfItemsOnly),
        packingPrice:
          withPacking && !localPackingRequired && localPackingRequired !== null
            ? Math.ceil(totalCostOfPacking + labourCost)
            : withPacking && localPackingRequired
            ? Math.ceil(totalCostOfPacking + labourCost)
            : null,
        packing_boxes_count: packingBoxesCount,
        price_of_bulky_items: costOfBulkyItems,
      };
      setTimeout(async () => {
        try {
          const res = await dispatch<any>(updateMoveService(moveServiceData));
          const e = unwrapResult(res);
          setLoadingMessage("Redirecting to user details...");
          const token = localStorage.getItem("authToken");
          const userCanonicalId = localStorage.getItem("user-canonical-id");
          if (token && userCanonicalId && moveService.user === null) {
            console.log("attaching");
            const params = {
              canonicalId: canonicalId,
              userId: localStorage.getItem("user-canonical-id"),
            };
            dispatch<any>(attachUserWithMove(params))
              .then(unwrapResult)
              .then(async (res: any) => {
                if (moveService && moveService.smartmoving_lead_id === null) {
                  await submitLeadToSmartMoving();
                }
                navigate(
                  `/${businessName}/${carrierCanonicalId}/move-summary/${canonicalId}`
                );
              });
          } else {
            navigate(
              `/${businessName}/${carrierCanonicalId}/user-details/${canonicalId}`
            );
          }
        } catch (err: any) {
          setError(err?.message || "Failed to update move service");
        } finally {
          setIsLoading(false);
        }
      }, 2000);
    } catch (err) {
      setIsLoading(false);
      setError("An unexpected error occurred");
    }
  };

  const [totalCubicFeet, setTotalCubicFeet] = useState(0.0);
  const [totalMovePrice, setTotalMovePrice] = useState(0.0);
  const [weMoveCommision, setWeMoveCommission] = useState(0.0);
  const [pickupCharges, setPickupCharges] = useState(0);
  const [priceOfItemsOnly, setPriceOfItemsOnly] = useState(0.0);
  const [costOfBulkyItems, setCostOfBulkyItems] = useState(0.0);
  const [bulkyItems, setBulkyItems] = useState<any>([]);
  const [squareFootage, setSquareFootage] = useState<any>(null);
  useEffect(() => {
    if (canonicalId) {
      getMoveById();
    }
  }, [canonicalId]);
  const extractStateFromAddress = (address: any) => {
    const addressParts = address.split(",");
    const state = addressParts[addressParts.length - 2].trim();
    return state;
  };
  const matchStateWithLocation = (state: any) => {
    const carrierLocations = moveService.carrier.locations;
    const matched = carrierLocations.find((location: any) =>
      location.location_name.includes(state)
    );
    return matched ? matched : null;
  };
  const getRequiredRatesAndCalculatePriceForLongDistance = () => {
    setRunFunction(false);
    const state = extractStateFromAddress(moveService.moving_from);
    const location = matchStateWithLocation(state);
    for (let pricingBracket of location.longDistanceRates) {
      const { rate_type, rate } = pricingBracket;
      const [minDistance, maxDistance] = rate_type
        .split(" to ")
        .map((item: any) => parseInt(item, 10));
      if (
        moveService.distance > minDistance &&
        moveService.distance <= maxDistance
      ) {
        console.log(
          moveService.distance,
          minDistance,
          maxDistance,
          rate,
          "===GOT IT"
        );
        const pricePerCubicFeet = parseFloat(rate);
        console.log(pricePerCubicFeet, "P");
        const totalVolume = Math.ceil(
          Number(totalCubicFeet) + Number(boxCubicFeet)
        );
        console.log(totalVolume, "FINAL VOLUME-----");
        const price = totalVolume * pricePerCubicFeet * 1.1;
        setPriceOfItemsOnly((total) => total + price);
        setTotalMovePrice((thisPrice) => thisPrice + price);
        //calculating the addtional stairs/elevator price at delivery location
        if (
          moveService.deliveryDetails.dwelling_type === "apartment" ||
          moveService.deliveryDetails.dwelling_type === "storage"
        ) {
          if (moveService.deliveryDetails.isElevator === true) {
            setTotalMovePrice(
              (thisPrice) =>
                thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
            );
          } else if (
            moveService.deliveryDetails.isElevator === false &&
            Number(moveService.deliveryDetails.floor_number > 2)
          ) {
            const additionalFloors =
              Number(moveService.deliveryDetails.floor_number) - 2;
            const flight_fee =
              additionalFloors *
              parseFloat(moveService.carrier.rate.extra_stairs_fee);
            setTotalMovePrice((total) => total + flight_fee);
          }
        }
        if (moveService.dwelling_type === "apartment") {
          if (moveService.isElevator === true) {
            setTotalMovePrice(
              (thisPrice) =>
                thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
            );
          } else if (
            moveService.isElevator === false &&
            moveService.isStairs === true &&
            moveService.floor_number > 2
          ) {
            const additionalFloors = Number(moveService.floor_number) - 2;
            const flight_fee =
              additionalFloors *
              parseFloat(moveService.carrier.rate.extra_stairs_fee);
            setTotalMovePrice((total) => total + flight_fee);
          }
        } else if (moveService.dwelling === "storage" && moveService.storage) {
          if (moveService.storage.isElevator === true) {
            setTotalMovePrice(
              (thisPrice) =>
                thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
            );
          } else if (
            moveService.storage.isElevator === false &&
            moveService.storage.isStairs === true &&
            Number(moveService.storage.storage_floor_number > 2)
          ) {
            const additionalFloors =
              Number(moveService.storage.storage_floor_number) - 2;
            const flight_fee =
              additionalFloors *
              parseFloat(moveService.carrier.rate.extra_stairs_fee);
            setTotalMovePrice((total) => total + flight_fee);
          }
        }
        //Price of bulky items
        let priceOfBulkyItems = 0;
        const itemList = JSON.parse(moveService.inventory.inventory);
        let bulkyItems: any[] = [];
        itemList.map((room: any) => {
          room.images.map((image: any) => {
            image.items.map((item: any) => {
              if (item.bulky === true && item.price !== null) {
                bulkyItems.push(item);
                priceOfBulkyItems += item.price;
              }
            });
          });
        });
        setBulkyItems(bulkyItems);
        setCostOfBulkyItems(priceOfBulkyItems);
        setTotalMovePrice((total) => total + priceOfBulkyItems);
      }
    }
    setTargeLongDistanceRates(location);
  };
  const [boxCubicFeet, setBoxCubicFeet] = useState(0.0);
  const [localPackingPrice, setLocalPackingPrice] = useState<any>(0.0);
  const getHoursPerSquareFoot = (squareFootage: any) => {
    if (squareFootage > 0 && squareFootage <= 600) {
      return 0.0042;
    } else if (squareFootage > 600 && squareFootage <= 999) {
      return 0.005;
    } else if (squareFootage > 999 && squareFootage <= 1399) {
      return 0.0038;
    } else if (squareFootage > 1399 && squareFootage <= 1999) {
      return 0.0036;
    } else if (squareFootage > 1999 && squareFootage <= 3400) {
      return 0.0038;
    }
    return 0;
  };
  const convertToHours = (timeString: string) => {
    // Regular expression to match the "hours and minutes" format
    const regexWithHoursAndMinutes = /(\d+)\s*hour?s?\s*(\d+)\s*min?s?/;
    // Regular expression to match only minutes (singular or plural)
    const regexWithMinutesOnly = /(\d+)\s*min?s?/;

    let totalHours = 0;

    // Check for "hours and minutes" format (e.g., "19 hours 32 mins")
    const matchesWithHoursAndMinutes = timeString.match(
      regexWithHoursAndMinutes
    );
    if (matchesWithHoursAndMinutes) {
      const hours = parseInt(matchesWithHoursAndMinutes[1]);
      const minutes = parseInt(matchesWithHoursAndMinutes[2]);
      totalHours = hours + minutes / 60;
    }
    // Check for "minutes only" format (e.g., "40 min" or "1 min")
    else {
      const matchesWithMinutesOnly = timeString.match(regexWithMinutesOnly);
      if (matchesWithMinutesOnly) {
        const minutes = parseInt(matchesWithMinutesOnly[1]);
        totalHours = minutes / 60;
      }
    }
    console.log(totalHours, "HOURS");
    return totalHours;
  };
  const [finalMoverRate, setFinalMoverRate] = useState(0.0);
  const getMoverRate = (numOfMovers: number) => {
    if (numOfMovers === 2) {
      setFinalMoverRate(moveService.carrier.rate.rate_2_mover);
      return Number(moveService.carrier.rate.rate_2_mover);
    } else if (numOfMovers === 3) {
      setFinalMoverRate(moveService.carrier.rate.rate_3_mover);
      return Number(moveService.carrier.rate.rate_3_mover);
    } else if (numOfMovers === 4) {
      setFinalMoverRate(moveService.carrier.rate.rate_4_mover);
      return Number(moveService.carrier.rate.rate_4_mover);
    } else if (numOfMovers === 5) {
      setFinalMoverRate(moveService.carrier.rate.rate_5_mover);
      return Number(moveService.carrier.rate.rate_5_mover);
    } else if (numOfMovers === 6) {
      setFinalMoverRate(
        Number(moveService.carrier.rate.rate_5_mover) +
          Number(moveService.carrier.rate.rate_additional_mover)
      );
      return (
        Number(moveService.carrier.rate.rate_5_mover) +
        Number(moveService.carrier.rate.rate_additional_mover)
      );
    }
    return 0;
  };
  const calculateLocalPacking = (squareFootage: number) => {
    let totalCost = 0;
    totalCost = Math.ceil(((squareFootage * 5.5) / 100) * 35);
    console.log(squareFootage, totalCost, "sq ft");
    setLocalPackingPrice(totalCost);
    // setTotalMovePrice((thisPrice) => thisPrice + totalCost);
    return totalCost;
  };
  const [runFunction, setRunFunction] = useState(false);
  const localMoveFormula = () => {
    // calculateLocalPacking(moveService.pickup_square_footage);
    let moverRate = 0;
    let totalHours;
    let truckCount = 1;
    const hoursPerSquareFoot = getHoursPerSquareFoot(
      moveService.pickup_square_footage
    );
    let numberOfMovers = 0;
    if (
      moveService.pickup_square_footage > 0 &&
      moveService.pickup_square_footage <= 1200
    ) {
      numberOfMovers = 2;
      moverRate = getMoverRate(numberOfMovers);
    } else if (
      moveService.pickup_square_footage > 1200 &&
      moveService.pickup_square_footage <= 2000
    ) {
      numberOfMovers = 3;
      moverRate = getMoverRate(numberOfMovers);
    } else if (
      moveService.pickup_square_footage > 2000 &&
      moveService.pickup_square_footage <= 3000
    ) {
      numberOfMovers = 4;
      moverRate = getMoverRate(numberOfMovers);
    } else if (
      moveService.pickup_square_footage > 3000 &&
      moveService.pickup_square_footage <= 4000
    ) {
      numberOfMovers = 5;
      truckCount = 2;
      moverRate = getMoverRate(numberOfMovers);
    } else if (moveService.pickup_square_footage > 4000) {
      numberOfMovers = 6;
      truckCount = 2;
      moverRate = getMoverRate(numberOfMovers);
    }
    totalHours =
      hoursPerSquareFoot * moveService.pickup_square_footage +
      convertToHours(moveService.duration_time);
    let totalCost =
      moverRate * totalHours +
      Number(truckCount * moveService.carrier.rate.truck_fee);
    setPriceOfItemsOnly((total) => total + totalCost);
    setTotalMovePrice((thisPrice) => thisPrice + totalCost);
    if (
      moveService.deliveryDetails.dwelling_type === "apartment" ||
      moveService.deliveryDetails.dwelling_type === "storage"
    ) {
      if (moveService.deliveryDetails.isElevator === true) {
        setTotalMovePrice(
          (thisPrice) =>
            thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
        );
      } else if (
        moveService.deliveryDetails.isElevator === false &&
        Number(moveService.deliveryDetails.floor_number > 2)
      ) {
        const additionalFloors =
          Number(moveService.deliveryDetails.floor_number) - 2;
        const flight_fee =
          additionalFloors *
          parseFloat(moveService.carrier.rate.extra_stairs_fee);
        setTotalMovePrice((total) => total + flight_fee);
      }
    }
    if (moveService.dwelling_type === "apartment") {
      if (moveService.isElevator === true) {
        setTotalMovePrice(
          (thisPrice) =>
            thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
        );
      } else if (
        moveService.isElevator === false &&
        moveService.isStairs === true &&
        moveService.floor_number > 2
      ) {
        const additionalFloors = Number(moveService.floor_number) - 2;
        const flight_fee =
          additionalFloors *
          parseFloat(moveService.carrier.rate.extra_stairs_fee);
        setTotalMovePrice((total) => total + flight_fee);
      }
    } else if (moveService.dwelling === "storage" && moveService.storage) {
      if (moveService.storage.isElevator === true) {
        setTotalMovePrice(
          (thisPrice) =>
            thisPrice + parseFloat(moveService.carrier.rate.elevator_fee)
        );
      } else if (
        moveService.storage.isElevator === false &&
        moveService.storage.isStairs === true &&
        Number(moveService.storage.storage_floor_number > 2)
      ) {
        const additionalFloors =
          Number(moveService.storage.storage_floor_number) - 2;
        const flight_fee =
          additionalFloors *
          parseFloat(moveService.carrier.rate.extra_stairs_fee);
        setTotalMovePrice((total) => total + flight_fee);
      }
    }
    if (moveService.items) {
      let bulkyFee = 0;
      let items = JSON.parse(moveService.items);
      console.log(items, "-items");
      if (items.length) {
        items.map((i: any) => {
          bulkyFee += i.fee;
          setTotalMovePrice((total) => total + i.fee);
        });
      }
      setCostOfBulkyItems(bulkyFee);
      console.log(bulkyFee, "fee");
    }
  };

  useEffect(() => {
    if (boxCubicFeet !== 0.0 && runFunction === true) {
      console.log("running thisss");
      if (moveService && moveService.distance > 200) {
        if (totalMovePrice === 0.0) {
          getRequiredRatesAndCalculatePriceForLongDistance();
        }
      }
    }
  }, [moveService, boxCubicFeet, runFunction]);
  const [totalCostOfPacking, setTotalCostOffPacking] = useState(0);

  useEffect(() => {
    if (moveService && totalCostOfPacking !== 0) {
      if (moveService.distance <= 200) {
        //Call Local Move Formula
        if (totalMovePrice === 0.0) {
          localMoveFormula();
        }
      }
    }
  }, [moveService, totalCostOfPacking]);
  // useEffect(() => {
  //   console.log(
  //     totalMovePrice,
  //     priceOfItemsOnly,
  //     totalCubicFeet,
  //     "TOTALSSSS-----------"
  //   );
  // }, [totalMovePrice, priceOfItemsOnly, totalCubicFeet]);
  const handleBack = () => {
    navigate(-1);
  };
  const [localPackingString, setLoaclPackingString] = useState("");
  const [localPackingRequired, setLocalPackingRequired] = useState<any>(null);
  const [labourCost, setLabourCost] = useState(0.0);
  useEffect(() => {
    if (labourCost !== 0.0) {
      console.log(labourCost, "labor cost is: ----");
    }
  }, [labourCost]);
  const handleLocalPacking = (event: any) => {
    const value = event.target.value;
    console.log(value);
    if (value === "With Packing") {
      setLoaclPackingString("With Packing");
      setLocalPackingRequired(true);
      setWithPacking(true);
      // setTotalMovePrice((total) => total + localPackingPrice);
    } else if (value === "Without Packing") {
      setLoaclPackingString("Without Packing");
      setLocalPackingRequired(false);
      setWithPacking(false);
      if (localPackingRequired !== null) {
        // setTotalMovePrice((total) => total - localPackingPrice);
      }
    }
  };
  const [isStuffFactorPopulated, setIsStuffFactorPopulated] = useState(false);
  return (
    <div>
      <Header />
      <StepProgress currentStep={5} />
      <Container
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: isMobile ? "93vh" : "80vh",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          padding: isMobile ? "20px" : "20px",
          background: "#f2f0f0",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
        }}
      >
        {isLoading && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme: any) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
            onClick={() => {
              setIsLoading(true);
            }}
          >
            <Box sx={{ width: "50%" }}>
              <LinearProgress />
              <Typography
                fontSize={16}
                fontWeight={500}
                textAlign="center"
                mt={1}
              >
                {loadingMessage}
              </Typography>
            </Box>
          </Backdrop>
        )}
        <Box sx={{ flexGrow: 1 }}>
          {/* <Typography
            fontWeight={700}
            fontSize={isMobile ? "16px" : "18px"}
            textAlign="center"
            mb={2}
          >
            Pricing
          </Typography>
          <Divider sx={{ background: "#D3D3D3", mb: 2 }} /> */}

          {/* {!isStorageOnly && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                fontWeight={400}
                fontSize={isMobile ? "16px" : "18px"}
                textAlign="left"
                mb={2}
              >
                The total price of the move with packing
              </Typography>
              <Typography
                fontWeight={900}
                fontSize={isMobile ? "20px" : "25px"}
                mb={2}
                color={theme.palette.primary.main}
              >
                ${withPackingPrice}
              </Typography>
            </Box>
          )} */}

          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              fontWeight={400}
              fontSize={isMobile ? "16px" : "18px"}
              textAlign="left"
              mb={2}
            >
              {isStorageOnly
                ? "The total price of storage"
                : "The total price of the move without packing"}
            </Typography>
            <Typography
              fontWeight={900}
              fontSize={isMobile ? "20px" : "25px"}
              mb={2}
              color={theme.palette.primary.main}
            >
              ${withoutPackingPrice}
            </Typography>
          </Box> */}
          {/* {moveService?.distance > 200 ? ( */}
          <Packing
            finalMoverRate={finalMoverRate}
            totalCostOfPacking={totalCostOfPacking}
            setTotalCostOffPacking={setTotalCostOffPacking}
            setBoxCubicFeet={setBoxCubicFeet}
            setTotalMovePrice={setTotalMovePrice}
            setPriceOfItemsOnly={setPriceOfItemsOnly}
            setPackingBoxesCount={setPackingBoxesCount}
            setLabourCost={setLabourCost}
            squareFootage={squareFootage}
            setIsStuffFactorPopulated={setIsStuffFactorPopulated}
            setRunFunction={setRunFunction}
          />
          {/* ) : null} */}
          {totalCostOfPacking !== 0 && moveService.distance > 200 ? (
            <Box sx={{ mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  padding: "12px",
                  borderRadius: "12px",
                }}
                onClick={() => setIsPackingDropdownOpen(!isPackingDropdownOpen)}
              >
                {/* <Typography fontSize={isMobile ? "14px" : "16px"}>
                  {selectedPackingOption === "Without Packing"
                    ? `${selectedPackingOption}: $${Math.ceil(totalMovePrice)}`
                    : selectedPackingOption === "With Packing"
                    ? `${selectedPackingOption}: $${Math.ceil(
                        totalCostOfPacking + totalMovePrice
                      )}`
                    : "Select your preference"}
                </Typography> */}

                {/* <ExpandMoreIcon
                  sx={{
                    transform: isPackingDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    color: theme.palette.primary.main,
                  }}
                /> */}
              </Box>
              <Divider sx={{ background: "#D3D3D3", mb: 2 }} />
              {isPackingDropdownOpen && (
                <Box
                  sx={{
                    mt: 1,
                    borderRadius: "12px",
                    padding: "12px",
                    width: "100%",
                  }}
                >
                  <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                      value={
                        selectedPackingOption.includes("With Packing")
                          ? "With Packing"
                          : selectedPackingOption.includes("Without Packing")
                          ? "Without Packing"
                          : ""
                      }
                      onChange={handlePackingOptionChange}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "center",
                      }}
                    >
                      {/* With Packing */}
                      <FormControlLabel
                        value="With Packing"
                        control={<Radio sx={{ display: "none" }} />}
                        label={
                          <Box
                            sx={{
                              px: 3,
                              py: 1.5,
                              borderRadius: "25px",
                              fontWeight: 600,
                              fontSize: "14px",
                              border:
                                selectedPackingOption === "With Packing"
                                  ? `2px solid ${theme.palette.primary.main}`
                                  : "1px solid #cbd5e1",
                              background:
                                selectedPackingOption === "With Packing"
                                  ? "rgba(37,99,235,0.1)"
                                  : "#fff",
                              color:
                                selectedPackingOption === "With Packing"
                                  ? theme.palette.primary.main
                                  : "#475569",
                              cursor: "pointer",
                              transition: "all .25s",
                              "&:hover": {
                                borderColor: theme.palette.primary.main,
                              },
                            }}
                          >
                            With Packing
                          </Box>
                        }
                        sx={{ m: 0 }}
                      />

                      {/* Without Packing */}
                      <FormControlLabel
                        value="Without Packing"
                        control={<Radio sx={{ display: "none" }} />}
                        label={
                          <Box
                            sx={{
                              px: 3,
                              py: 1.5,
                              borderRadius: "25px",
                              fontWeight: 600,
                              fontSize: "14px",
                              border:
                                selectedPackingOption === "Without Packing"
                                  ? `2px solid ${theme.palette.primary.main}`
                                  : "1px solid #cbd5e1",
                              background:
                                selectedPackingOption === "Without Packing"
                                  ? "rgba(37,99,235,0.1)"
                                  : "#fff",
                              color:
                                selectedPackingOption === "Without Packing"
                                  ? theme.palette.primary.main
                                  : "#475569",
                              cursor: "pointer",
                              transition: "all .25s",
                              "&:hover": {
                                borderColor: theme.palette.primary.main,
                              },
                            }}
                          >
                            Without Packing
                          </Box>
                        }
                        sx={{ m: 0 }}
                      />
                    </RadioGroup>
                  </FormControl>

                  <Box
                    sx={{
                      my: 2,
                      position: "relative",
                      p: 2.5,
                      borderRadius: "18px",
                      background: "linear-gradient(135deg, #ffffff, #f7faff)",
                      border:
                        selectedPackingOption === "With Packing"
                          ? `2px solid ${theme.palette.primary.main}`
                          : "1px solid #e2e8f0",
                      boxShadow:
                        selectedPackingOption === "With Packing"
                          ? "0 8px 18px rgba(37, 99, 235, 0.18)"
                          : "0 4px 10px rgba(0,0,0,0.08)",
                      transition: "all 0.28s ease",
                      "&:hover": { transform: "translateY(-4px)" },
                    }}
                  >
                    {/* Best Value Ribbon */}
                    {selectedPackingOption === "With Packing" && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          background: theme.palette.primary.main,
                          color: "#fff",
                          fontSize: "10px",
                          fontWeight: 700,
                          px: 1.4,
                          py: 0.7,
                          borderRadius: "8px",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                          transform: "rotate(10deg)",
                        }}
                      >
                        BEST VALUE ⭐
                      </Box>
                    )}

                    {/* Title */}
                    <Typography
                      fontWeight={700}
                      fontSize={isMobile ? 15 : 17}
                      mb={1}
                      sx={{ color: "#1e293b" }}
                    >
                      Total Moving Cost
                    </Typography>

                    {/* Sub text */}
                    <Typography
                      fontSize={isMobile ? 12 : 13}
                      color="#64748B"
                      mb={1.5}
                      sx={{ fontWeight: 500 }}
                    >
                      Based on your selected packing method.
                    </Typography>

                    <Divider sx={{ my: 1.2 }} />

                    {/* Price */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 1.2,
                      }}
                    >
                      <Box>
                        <Typography
                          fontSize={isMobile ? 12 : 14}
                          color="#475569"
                        >
                          Estimated Total
                        </Typography>

                        <Typography
                          fontWeight={800}
                          fontSize={isMobile ? 22 : 26}
                          sx={{
                            background:
                              "linear-gradient(90deg,#2563eb,#4f46e5)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          {selectedPackingOption === "With Packing"
                            ? `$${Math.ceil(
                                totalMovePrice + totalCostOfPacking + labourCost
                              )}`
                            : `$${Math.ceil(totalMovePrice)}`}
                        </Typography>
                      </Box>

                      {/* Info Button */}
                      {selectedPackingOption === "With Packing" && (
                        <Tooltip
                          title={`Includes packing cost: $${Math.ceil(
                            totalCostOfPacking + labourCost
                          )}`}
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            sx={{
                              background: "#fff",
                              border: "1px solid #e2e8f0",
                              "&:hover": { background: "#f1f5f9" },
                            }}
                          >
                            <InfoOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: theme.palette.primary.main,
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          ) : null}
          {moveService?.distance <= 200 && isStuffFactorPopulated === true ? (
            <Box>
              <Box
                sx={{
                  mt: 1,
                  borderRadius: "12px",
                  padding: "12px",
                  width: "100%",
                }}
              >
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    onChange={handleLocalPacking}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 2,
                      justifyContent: "center",
                    }}
                  >
                    {/* With Packing */}
                    <FormControlLabel
                      value="With Packing"
                      control={<Radio sx={{ display: "none" }} />}
                      label={
                        <Box
                          sx={{
                            px: 3,
                            py: 1.5,
                            borderRadius: "25px",
                            fontWeight: 600,
                            fontSize: "14px",
                            border:
                              localPackingString === "With Packing"
                                ? `2px solid ${theme.palette.primary.main}`
                                : "1px solid #cbd5e1",
                            background:
                              localPackingString === "With Packing"
                                ? "rgba(37,99,235,0.1)"
                                : "#fff",
                            color:
                              localPackingString === "With Packing"
                                ? theme.palette.primary.main
                                : "#475569",
                            cursor: "pointer",
                            transition: "all .25s",
                            "&:hover": {
                              borderColor: theme.palette.primary.main,
                            },
                          }}
                        >
                          With Packing
                        </Box>
                      }
                      sx={{ m: 0 }}
                    />

                    {/* Without Packing */}
                    <FormControlLabel
                      value="Without Packing"
                      control={<Radio sx={{ display: "none" }} />}
                      label={
                        <Box
                          sx={{
                            px: 3,
                            py: 1.5,
                            borderRadius: "25px",
                            fontWeight: 600,
                            fontSize: "14px",
                            border:
                              localPackingString === "Without Packing"
                                ? `2px solid ${theme.palette.primary.main}`
                                : "1px solid #cbd5e1",
                            background:
                              localPackingString === "Without Packing"
                                ? "rgba(37,99,235,0.1)"
                                : "#fff",
                            color:
                              localPackingString === "Without Packing"
                                ? theme.palette.primary.main
                                : "#475569",
                            cursor: "pointer",
                            transition: "all .25s",
                            "&:hover": {
                              borderColor: theme.palette.primary.main,
                            },
                          }}
                        >
                          Without Packing
                        </Box>
                      }
                      sx={{ m: 0 }}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              {moveService.distance <= 200 && localPackingString !== "" ? (
                <Box
                  sx={{
                    mt: 2,
                    position: "relative",
                    p: 2.2,
                    borderRadius: "18px",
                    background: "linear-gradient(135deg, #ffffff, #f8fafc)",
                    border: localPackingRequired
                      ? `2px solid ${theme.palette.primary.main}`
                      : "1px solid #e2e8f0",
                    boxShadow: localPackingRequired
                      ? "0 8px 18px rgba(37,99,235,0.18)"
                      : "0 4px 10px rgba(0,0,0,0.07)",
                    transition: "all 0.28s ease",
                    "&:hover": { transform: "translateY(-4px)" },
                  }}
                >
                  {/* Ribbon */}
                  {localPackingRequired && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        background: theme.palette.primary.main,
                        color: "#fff",
                        fontSize: "10px",
                        fontWeight: 700,
                        px: 1.4,
                        py: 0.6,
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        transform: "rotate(9deg)",
                      }}
                    >
                      BEST VALUE ⭐
                    </Box>
                  )}

                  <Typography
                    fontWeight={700}
                    fontSize={isMobile ? 15 : 17}
                    mb={1}
                  >
                    Total Moving Cost
                  </Typography>

                  <Typography
                    fontSize={isMobile ? 12 : 13}
                    color="#64748B"
                    mb={1}
                    sx={{ fontWeight: 500 }}
                  >
                    Local move pricing summary.
                  </Typography>

                  <Divider sx={{ my: 1 }} />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1.2,
                    }}
                  >
                    <Box>
                      <Typography fontSize={isMobile ? 12 : 14} color="#475569">
                        Estimated Total
                      </Typography>

                      <Typography
                        fontWeight={800}
                        fontSize={isMobile ? 22 : 26}
                        sx={{
                          background: "linear-gradient(90deg,#2563eb,#4f46e5)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        {localPackingRequired
                          ? `$${Math.ceil(
                              totalMovePrice + totalCostOfPacking + labourCost
                            )}`
                          : `$${Math.ceil(totalMovePrice)}`}
                      </Typography>
                    </Box>

                    {localPackingRequired && (
                      <Tooltip
                        title={`Includes packing cost: $${Math.ceil(
                          totalCostOfPacking + labourCost
                        )}`}
                        placement="top"
                        arrow
                      >
                        <IconButton
                          size="small"
                          sx={{
                            background: "#fff",
                            border: "1px solid #e2e8f0",
                            "&:hover": { background: "#f1f5f9" },
                          }}
                        >
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: theme.palette.primary.main,
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "20px",
            marginTop: "auto",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              borderRadius: "20px",
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
              "&:hover": { backgroundColor: "#357ABD" },
            }}
            onClick={handleContinue}
            disabled={!isStorageOnly && !selectedPackingOption}
          >
            Continue
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default Pricing;
